<div class="login-bg">
  <div class="card login-card">
    <img src="./assets/logo.png" alt="Logo stf" class="logo" />

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="field hide" [ngClass]="{ show: isAdmin }">
        <label>Unesi korisničko ime</label>
        <input
          type="text"
          aria-describedby="username1-help"
          pInputText
          formControlName="username"
        />
      </div>

      <div class="field">
        <label>Unesi šifru</label>
        <input
          type="password"
          aria-describedby="username1-help"
          pInputText
          formControlName="password"
        />
      </div>

      <button class="main-btn w-100" type="submit">
        <div class="flex align-items-center">
          <p-progressSpinner
            *ngIf="loading"
            [style]="{ width: '15px', height: '15px' }"
            styleClass="custom-spinner mr-2"
            strokeWidth="8"
            animationDuration=".5s"
          ></p-progressSpinner>
          Prijavi se
        </div>
        <i class="pi pi-sign-in"></i>
      </button>
      <p-message
        severity="error"
        *ngIf="loginFailed"
        text="Šifra ili korisničko ime su pogrešni, pokušajte ponovo."
        styleClass="mt-2"
      ></p-message>
    </form>

    <div class="w-100 flex align-items-center mt-3">
      <p-inputSwitch [(ngModel)]="isAdmin"></p-inputSwitch>
      <span class="ml-2">Administrator</span>
    </div>
    <a class="mt-6" (click)="showContact = !showContact"
      >Kontaktiraj administratora</a
    >

    <section
      *ngIf="showContact"
      class="mt-3 flex flex-column align-items-center"
    >
      <strong>Broj telefona: </strong>
      <span>060 123 456</span>
      <strong class="mt-2">E-mail: </strong>
      <span>podrska@stevanovic.com</span>
    </section>
  </div>
</div>
